(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fc-personnalisation"] && !Shopify.designMode) return;
  try {
    (function () {

  function fcInitPersonalization() {

    document.querySelectorAll('.fc-personal').forEach(function(block) {

      if (block.dataset.fcReady === 'yes') {
        return;
      }

      const section = block.closest('.shopify-section');

      let form = document.getElementById(
        block.dataset.productForm
      );

      if (!form && section) {
        form = section.querySelector(
          'form[action*="/cart/add"]'
        );
      }

      if (!form) {
        return;
      }

      block.dataset.fcReady = 'yes';

      if (!form.id) {
        form.id = 'fc-form-' + block.id;
      }

      const fields = block.querySelectorAll(
        '[data-fc-property]'
      );

      const details = block.querySelector(
        '[data-fc-details]'
      );

      const textInput = block.querySelector(
        '[data-fc-text]'
      );

      const file = block.querySelector(
        '[data-fc-file]'
      );

      // Formulaire compatible avec les fichiers.
      if (file) {
        form.enctype = 'multipart/form-data';
        form.setAttribute(
          'enctype',
          'multipart/form-data'
        );
      }

      // Relier les champs au formulaire produit.
      fields.forEach(function(field) {

        field.setAttribute('form', form.id);

        field.addEventListener('invalid', function() {

          if (details) {
            details.open = true;
          }

        });

      });

      // Validation avant ajout au panier.
      form.addEventListener('submit', function(event) {

        for (const field of fields) {

          if (!field.checkValidity()) {

            if (details) {
              details.open = true;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            field.reportValidity();

            return;
          }

        }

      }, true);

      // Compteur de caractères.
      if (textInput) {

        const counter = block.querySelector(
          '[data-fc-count]'
        );

        function updateCount() {

          if (counter) {
            counter.textContent = textInput.value.length;
          }

        }

        textInput.addEventListener(
          'input',
          updateCount
        );

        updateCount();

      }

      // Si mode texte, pas de photo à gérer.
      if (!file) {
        return;
      }

      const preview = block.querySelector(
        '[data-fc-preview]'
      );

      const image = block.querySelector(
        '[data-fc-img]'
      );

      const filename = block.querySelector(
        '[data-fc-filename]'
      );

      const removeButton = block.querySelector(
        '[data-fc-remove]'
      );

      const error = block.querySelector(
        '[data-fc-error]'
      );

      let objectURL = null;

      function clearPreview() {

        if (objectURL) {
          URL.revokeObjectURL(objectURL);
          objectURL = null;
        }

        if (preview) {
          preview.hidden = true;
        }

        if (image) {
          image.src =
            'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }

        if (filename) {
          filename.textContent = '';
        }

      }

      function showError(message) {

        if (!error) {
          return;
        }

        error.textContent = message;
        error.hidden = !message;

      }

      // Sélection de photo.
      file.addEventListener('change', function() {

        clearPreview();
        showError('');
        file.setCustomValidity('');

        const selected = file.files
          ? file.files[0]
          : null;

        if (!selected) {
          return;
        }

        // Vérifier que le fichier est une image.
        if (!selected.type.startsWith('image/')) {

          file.value = '';

          showError(
            'Veuillez sélectionner une image valide.'
          );

          file.setCustomValidity(
            'Veuillez sélectionner une image valide.'
          );

          file.reportValidity();

          return;
        }

        objectURL = URL.createObjectURL(selected);

        if (image) {
          image.src = objectURL;
        }

        if (filename) {
          filename.textContent = selected.name;
        }

        if (preview) {
          preview.hidden = false;
        }

      });

      // Supprimer la photo.
      if (removeButton) {

        removeButton.addEventListener(
          'click',
          function() {

            file.value = '';
            file.setCustomValidity('');

            showError('');
            clearPreview();

          }
        );

      }

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      fcInitPersonalization
    );

  } else {

    fcInitPersonalization();

  }

  document.addEventListener(
    'shopify:section:load',
    fcInitPersonalization
  );

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fc-prix-produit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fc-product-price')) {
    customElements.define('fc-product-price', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();

        this.scope =
          this.closest('product-info') ||
          this.closest('.shopify-section') ||
          this.parentElement;

        const options = { signal: this.events.signal };

        this.scope.addEventListener('change', (event) => {
          const input = event.target;

          if (!input.matches?.('[name="id"]') || !input.form) return;

          if (
            input.closest('product-card, quick-add-modal, quick-add-dialog') !==
            this.closest('product-card, quick-add-modal, quick-add-dialog')
          ) return;

          const productId =
            input.form.querySelector('[name="product-id"]')?.value;

          if (productId && productId !== this.dataset.productId) return;

          this.refresh(input.value);
        }, options);

        this.scope.addEventListener('variant:update', (event) => {
          if (
            !(event.target instanceof Element) ||
            event.target.closest('product-card, quick-add-modal, quick-add-dialog') !==
            this.closest('product-card, quick-add-modal, quick-add-dialog')
          ) return;

          this.applyHTML(
            event.detail?.data?.html || event.detail?.html
          );
        }, options);

        this.scope.addEventListener('shopify:product:select', async (event) => {
          if (
            !(event.target instanceof Element) ||
            event.target.closest('product-card, quick-add-modal, quick-add-dialog') !==
            this.closest('product-card, quick-add-modal, quick-add-dialog')
          ) return;

          if (!event.promise) return;

          const ticket = this.ticket = (this.ticket || 0) + 1;
          this.request?.abort();

          try {
            const result = await event.promise;

            if (this.isConnected && ticket === this.ticket) {
              this.applyHTML(result?.detail?.html);
            }
          } catch (error) {
            if (
              error.name !== 'AbortError' &&
              ticket === this.ticket
            ) {
              this.hidden = true;
            }
          }
        }, options);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.request?.abort();
        this.ticket = (this.ticket || 0) + 1;
      }

      applyHTML(html) {
        if (typeof html === 'string') {
          html = new DOMParser().parseFromString(html, 'text/html');
        }

        const next = html?.id === this.id
          ? html
          : html?.getElementById?.(this.id) ||
            html?.querySelector?.('#' + CSS.escape(this.id));

        const content = next?.querySelector('[data-fc-price-content]');

        if (!content || !this.isConnected) return;

        this.request?.abort();

        this.querySelector('[data-fc-price-content]').innerHTML =
          content.innerHTML;

        this.dataset.variantId = next.dataset.variantId;
        this.dataset.productId = next.dataset.productId;
        this.dataset.productUrl = next.dataset.productUrl;

        this.hidden = next.hidden;
        this.removeAttribute('aria-busy');
      }

      async refresh(variantId) {
        this.request?.abort();

        if (!variantId) {
          this.hidden = true;
          return;
        }

        if (variantId === this.dataset.variantId) {
          this.hidden = false;
          return;
        }

        const request = this.request = new AbortController();

        const url = new URL(
          this.dataset.productUrl,
          window.location.origin
        );

        url.searchParams.set('variant', variantId);
        url.searchParams.set('section_id', this.dataset.sectionId);

        this.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(url, {
            signal: request.signal
          });

          if (!response.ok) {
            throw new Error('Price request failed');
          }

          const html = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );

          if (
            request !== this.request ||
            request.signal.aborted ||
            !this.isConnected
          ) return;

          const next = html.getElementById(this.id);

          if (next?.dataset.variantId !== variantId) {
            throw new Error('Variant unavailable');
          }

          this.applyHTML(html);
        } catch (error) {
          if (
            error.name !== 'AbortError' &&
            request === this.request
          ) {
            this.hidden = true;
          }
        } finally {
          if (request === this.request) {
            this.removeAttribute('aria-busy');
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
